class ZehnShippingReturns extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => {
      if (this.isConnected && !this.events) this.initialize();
    });
  }

  initialize() {
    this.nav = this.querySelector('[data-shipping-nav]');
    this.links = [...this.querySelectorAll('[data-shipping-tab]')];
    this.sections = [...this.querySelectorAll('[data-shipping-section]')];
    if (!this.nav || this.links.length !== 2 || this.sections.length !== 2) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.addEventListener('click', (event) => {
      const link = event.target.closest('[data-shipping-tab]');
      if (!link || !this.links.includes(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const section = this.sections.find((item) => '#' + item.id === link.hash);
      if (!section) return;
      event.preventDefault();
      this.update();
      history.replaceState(history.state, '', link.hash);
      section.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      if (event.detail === 0) section.querySelector('h2')?.focus({ preventScroll: true });
    }, options);
    const queue = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.isConnected) this.update();
      });
    };
    window.addEventListener('scroll', queue, { ...options, capture: true, passive: true });
    window.addEventListener('resize', queue, options);
    this.update();
    const initial = this.sections.find((section) => '#' + section.id === location.hash);
    if (initial) requestAnimationFrame(() => {
      if (this.isConnected) initial.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
  }

  update() {
    let headerBottom = 0;
    for (const header of document.querySelectorAll('header, sticky-header, .shopify-section-header-sticky')) {
      const position = getComputedStyle(header).position;
      const bounds = header.getBoundingClientRect();
      if ((position === 'fixed' || position === 'sticky') && bounds.top < 150 && bounds.bottom > 0 && bounds.bottom < innerHeight / 2) headerBottom = Math.max(headerBottom, bounds.bottom);
    }
    const top = Math.ceil(headerBottom + 8);
    const targetTop = top + this.nav.offsetHeight + 24;
    let scrollInset = 0;
    for (let parent = this.parentElement; parent; parent = parent.parentElement) {
      const style = getComputedStyle(parent);
      if (/^(auto|scroll)$/.test(style.overflowY) && parent.scrollHeight > parent.clientHeight + 1) {
        scrollInset = parent.getBoundingClientRect().top + (parseFloat(style.paddingTop) || 0);
        break;
      }
    }
    this.style.setProperty('--zsr-sticky-top', Math.ceil(top - scrollInset) + 'px');
    this.style.setProperty('--zsr-target-top', targetTop + 'px');
    let active = this.sections[0];
    for (const section of this.sections) if (section.getBoundingClientRect().top <= targetTop + 12) active = section;
    for (const link of this.links) {
      if (link.hash === '#' + active.id) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    }
  }

  disconnectedCallback() {
    this.events?.abort();
    this.events = null;
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = null;
  }
}

if (!customElements.get('zehn-shipping-returns')) customElements.define('zehn-shipping-returns', ZehnShippingReturns);
